import classNames from 'classnames'
import React from 'react'
import { Button, Icon } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import styles from './HeaderButton.module.css'

export interface HeaderButtonProps {
  onClick: () => void
  children: React.ReactNode
  className?: string
  ariaLabel?: string
}

export const HeaderButton: React.FC<HeaderButtonProps> = ({
  onClick,
  children,
  className,
  ariaLabel,
}) => {
  const { t } = useTranslation(['common'])

  return (
    <>
      <div className={styles.mobileWrapper}>
        <Button
          onClick={onClick}
          variant="text"
          className={classNames(
            styles.mobileLink,
            'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2'
          )}
          aria-label={ariaLabel || t('common:backToHome')}
        >
          <Icon icon="arrow-left" className="mr-4 fill-current w-4" />
          {children}
        </Button>
      </div>

      <Button
        onClick={onClick}
        variant="pill"
        icon="angle-left"
        aria-label={ariaLabel || t('common:backToHome')}
        className={classNames(
          'hidden min-tablet:inline-flex items-center mt-6 mb-3',
          styles.desktopButton,
          className
        )}
      >
        {children}
      </Button>
    </>
  )
}
